import React from "react";
import Layout from "../components/layout";
import Testimonial from "../components/Testimonial";
import Deco from "../components/Deco";

export default function AboutPage() {
  return (
    <Layout>
      <div className="deco-wrap">
        <Deco name="five" className="deco-about deco-about--right" />
      </div>
      <div className="container about-page">
        <div className="about-hero">
          <h1 className="about-hero__title">
            Design that works as hard&nbsp;as&nbsp;you&nbsp;do
          </h1>
          <p className="about-hero__lead">
            I'm Casey, a designer and developer who helps small businesses look
            like they've got their act together (because you do, you just need
            the visuals to match).
          </p>
        </div>

        <section className="about-section">
          <div className="about-section__header">
            <h2 className="about-section__title">What I can help with</h2>
            <p className="about-section__subtitle">
              I do a bit of everything, which means you don't have to hire five
              different people to get a cohesive result.
            </p>
          </div>

          <div className="about-cards">
            <div className="about-card">
              <div className="about-card__icon">&#9678;</div>
              <div className="about-card__title">Brand Identity</div>
              <p className="about-card__text">
                Logos, colors, fonts. All the pieces that make people recognize
                you. I'll build a system that works whether it's on a business
                card or a billboard.
              </p>
            </div>

            <div className="about-card">
              <div className="about-card__icon">&#9672;</div>
              <div className="about-card__title">Web Design + Development</div>
              <p className="about-card__text">
                Websites that look good and actually work. I handle the design
                and the code, so nothing gets lost in translation.
              </p>
            </div>

            <div className="about-card">
              <div className="about-card__icon">&#9670;</div>
              <div className="about-card__title">Packaging + Print</div>
              <p className="about-card__text">
                Labels, menus, signage, business cards. Anything that exists in
                the real world. I'll make sure it all feels like it belongs
                together.
              </p>
            </div>

            <div className="about-card">
              <div className="about-card__icon">&#9673;</div>
              <div className="about-card__title">Product Labels</div>
              <p className="about-card__text">
                If you sell something on a shelf, I can design labels that stand
                out and tell your story at a glance.
              </p>
            </div>

            <div className="about-card">
              <div className="about-card__icon">&#10070;</div>
              <div className="about-card__title">CMS Setup</div>
              <p className="about-card__text">
                I'll set up your site so you can update it yourself. No calling
                me every time you need to change a photo.
              </p>
            </div>

            <div className="about-card">
              <div className="about-card__icon">&#10022;</div>
              <div className="about-card__title">Ongoing Site Help</div>
              <p className="about-card__text">
                Don't want to think about your website after launch? I handle
                updates, backups, and keeping things running smoothly.
              </p>
            </div>
          </div>
        </section>

        <section className="about-section about-section--process">
          <div className="about-section__header">
            <h2 className="about-section__title">How it works</h2>
            <p className="about-section__subtitle">
              No 47-page proposals or endless revision rounds. Just a
              straightforward process that gets things done.
            </p>
          </div>

          <div className="about-steps">
            <div className="about-step">
              <span className="about-step__number">01</span>
              <div className="about-step__content">
                <h3 className="about-step__title">We start with a conversation</h3>
                <p className="about-step__text">
                  I'll ask about your business, your customers, and what you're
                  actually trying to accomplish. Then I'll put together a plan
                  that makes sense for your budget and timeline.
                </p>
              </div>
            </div>

            <div className="about-step">
              <span className="about-step__number">02</span>
              <div className="about-step__content">
                <h3 className="about-step__title">Design that earns its place</h3>
                <p className="about-step__text">
                  Every color, font, and layout choice has a reason behind it.
                  The goal is always to make things clearer and easier for the
                  people you're trying to reach.
                </p>
              </div>
            </div>

            <div className="about-step">
              <span className="about-step__number">03</span>
              <div className="about-step__content">
                <h3 className="about-step__title">Launch and beyond</h3>
                <p className="about-step__text">
                  Your project goes live, and I stick around to make sure
                  everything is running smoothly. Need tweaks down the road? I'm
                  just an email away.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className="container about-testimonial-header">
        <h2 className="about-section__title">What clients are saying</h2>
      </div>
      <Testimonial />
    </Layout>
  );
}
